import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { COLUMN_CODE, TableManger, TABLES } from '../../managers/TableManger';
import AttendanceService from '../../services/AttendanceService';
import Table from '../../services/table';
const initialState = {
    data: {},
    columnConfig: [],
    status: 'idle',
    formData: {
        // liability: [],
        // assets: [],
        // paymentTerm: [],
        // sequenceFormats: []
    }
};
export const fetchTeamAttendance = createAsyncThunk('teamAttendance', async () => {
    const response = await AttendanceService.getTeamAttendanceByPage();
    return response;
});
export const getRecordsById = createAsyncThunk(
    "record/getRecordsById",
    async (data, thunkAPI) => {
      const tableId = TableManger.getTableId(data.tableName);
      const params = data.params || {};
    
      const response = await Table.getRecordById(data.recordId, tableId, params);
      return response;
    }
  );
export const TeamAttendanceSlice = createSlice({
    name: 'teamAttendance',
    initialState,
    reducers: {
        addTeamAttendanceColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        addColumnToTeamAttendanceColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTeamAttendance.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchTeamAttendance.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
    }
});

export const { addTeamAttendanceColumnConfig, addColumnToTeamAttendanceColumnConfig } =
TeamAttendanceSlice.actions;

export const selectTeamAttendance = (state) => {
    return state.teamAttendance.data
};

export const selectTeamAttendanceColumnConfig = (state) =>
    state.teamAttendance.columnConfig;

export default TeamAttendanceSlice.reducer;